const step3data1 = [
  {
    'service_package_id': 1,
    'service_package_name': 'Retail Entry',
    'service_package_desc': '零售业基础方案',
    'service_package_image': [
      'https://api.miepay.xyz/storage/shop/progress/service/servicePackage/retail.jpg'
    ],
    'service_package_price': 21720,
    'created_at': null,
    'updated_at': null,
    'deleted_at': null,
    'is_choose': false,
    'service': [
      {
        'service_id': 16,
        'service_name': 'Mie Wireless internet 5/2 Unlimited',
        'service_name_str': 'MieWirelessinternet52Unlimited_str',
        'service_desc': 'MieWirelessinternet52Unlimited',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/InternetService/wareless nation/wn-miepay.jpg'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/InternetService/wareless nation/wn-miepay.jpg\']',
        'service_price': 7000,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 1,
          'service_id': 16
        },
        'service_model': []
      },
      {
        'service_id': 17,
        'service_name': 'SUNMI D2s Lite',
        'service_name_str': 'SUNMID2sLite_str',
        'service_desc': `SUNMID2sLite`,
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/PosHardware/sunmi/D2s Lite/02.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/PosHardware/sunmi/D2s Lite/02.png\']',
        'service_price': 6250,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 1,
          'service_id': 17
        },
        'service_model': []
      },
      {
        'service_id': 10,
        'service_name': 'Taptouch S300H',
        'service_name_str': 'TaptouchS300H_str',
        'service_desc': 'TaptouchS300H',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch S300H/开盖.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch S300H/开盖.png\']',
        'service_price': 990,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 1,
          'service_id': 10
        },
        'service_model': []
      },
      {
        'service_id': 8,
        'service_name': 'Taptouch  C3540',
        'service_name_str': 'TaptouchC3540_str',
        'service_desc': 'TaptouchC3540',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch  C3540/C3540-open-Logo.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch  C3540/C3540-open-Logo.png\']',
        'service_price': 590,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 1,
          'service_id': 8
        },
        'service_model': []
      },
      {
        'service_id': 9,
        'service_name': 'Taptouch N2050',
        'service_name_str': 'TaptouchN2050_str',
        'service_desc': 'TaptouchN2050',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch 2050/2-empty.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch 2050/2-empty.png\']',
        'service_price': 990,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 1,
          'service_id': 9
        },
        'service_model': []
      },
      {
        'service_id': 15,
        'service_name': 'Hospitality Fast Grow ',
        'service_name_str': 'HospitalityFastGrow_str',
        'service_desc': 'HospitalityFastGrow',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/PosSystem/TAPTOUCH LOGO.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/PosSystem/TAPTOUCH LOGO.png\']',
        'service_price': 5900,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 1,
          'service_id': 15
        },
        'service_model': []
      }
    ]
  },
  {
    'service_package_id': 2,
    'service_package_name': 'Retail Advance',
    'service_package_desc': `零售业高级方案`,
    'service_package_image': [
      'https://api.miepay.xyz/storage/shop/progress/service/servicePackage/retail.jpg'
    ],
    'service_package_price': 31505,
    'created_at': null,
    'updated_at': null,
    'deleted_at': null,
    'is_choose': false,
    'service': [
      {
        'service_id': 18,
        'service_name': 'Mie Wireless internet 20/5 Unlimited',
        'service_name_str': 'MieWirelessinternet205Unlimited_str',
        'service_desc': 'MieWirelessinternet205Unlimited',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/InternetService/wareless nation/wn-miepay.jpg'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/InternetService/wareless nation/wn-miepay.jpg\']',
        'service_price': 12900,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 2,
          'service_id': 18
        },
        'service_model': []
      },
      {
        'service_id': 19,
        'service_name': 'SUNMI T2s Dual Touch',
        'service_name_str': 'SUNMIT2sDualTouch_str',
        'service_desc': `SUNMIT2sDualTouch`,
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/PosHardware/sunmi/T2/T2双大屏_左侧面.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/PosHardware/sunmi/T2/T2双大屏_左侧面.png\']',
        'service_price': 10500,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 2,
          'service_id': 19
        },
        'service_model': []
      },
      {
        'service_id': 10,
        'service_name': 'Taptouch S300H',
        'service_name_str': 'TaptouchS300H_str',
        'service_desc': 'TaptouchS300H',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch S300H/开盖.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch S300H/开盖.png\']',
        'service_price': 990,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 2,
          'service_id': 10
        },
        'service_model': []
      },
      {
        'service_id': 8,
        'service_name': 'Taptouch  C3540',
        'service_name_str': 'TaptouchC3540_str',
        'service_desc': 'TaptouchC3540',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch  C3540/C3540-open-Logo.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch  C3540/C3540-open-Logo.png\']',
        'service_price': 590,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 2,
          'service_id': 8
        },
        'service_model': []
      },
      {
        'service_id': 15,
        'service_name': 'Hospitality Fast Grow ',
        'service_name_str': 'HospitalityFastGrow_str',
        'service_desc': 'HospitalityFastGrow',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/PosSystem/TAPTOUCH LOGO.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/PosSystem/TAPTOUCH LOGO.png\']',
        'service_price': 5900,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 2,
          'service_id': 15
        },
        'service_model': []
      },
      {
        'service_id': 7,
        'service_name': 'Smart Box',
        'service_name_str': 'SmartBox_str',
        'service_desc': 'SmartBox',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/1.jpg',
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/2.jpg',
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/3.jpg'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/1.jpeg\',\'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/2.jpeg\',\'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/3.jpeg\']',
        'service_price': 625,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 2,
          'service_id': 7
        },
        'service_model': []
      }
    ]
  },
  {
    'service_package_id': 3,
    'service_package_name': 'Hospitality Entry',
    'service_package_desc': '服务业基础方案',
    'service_package_image': [
      'https://api.miepay.xyz/storage/shop/progress/service/servicePackage/Hospitality.jpg'
    ],
    'service_package_price': 20730,
    'created_at': null,
    'updated_at': null,
    'deleted_at': null,
    'is_choose': false,
    'service': [
      {
        'service_id': 16,
        'service_name': 'Mie Wireless internet 5/2 Unlimited',
        'service_name_str': 'MieWirelessinternet52Unlimited_str',
        'service_desc': 'MieWirelessinternet52Unlimited',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/InternetService/wareless nation/wn-miepay.jpg'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/InternetService/wareless nation/wn-miepay.jpg\']',
        'service_price': 7000,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 3,
          'service_id': 16
        },
        'service_model': []
      },
      {
        'service_id': 17,
        'service_name': 'SUNMI D2s Lite',
        'service_name_str': 'SUNMID2sLite_str',
        'service_desc': `SUNMID2sLite`,
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/PosHardware/sunmi/D2s Lite/02.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/PosHardware/sunmi/D2s Lite/02.png\']',
        'service_price': 6250,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 3,
          'service_id': 17
        },
        'service_model': []
      },
      {
        'service_id': 10,
        'service_name': 'Taptouch S300H',
        'service_name_str': 'TaptouchS300H_str',
        'service_desc': 'TaptouchS300H',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch S300H/开盖.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch S300H/开盖.png\']',
        'service_price': 990,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 3,
          'service_id': 10
        },
        'service_model': []
      },
      {
        'service_id': 8,
        'service_name': 'Taptouch  C3540',
        'service_name_str': 'TaptouchC3540_str',
        'service_desc': 'TaptouchC3540',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch  C3540/C3540-open-Logo.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch  C3540/C3540-open-Logo.png\']',
        'service_price': 590,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 3,
          'service_id': 8
        },
        'service_model': []
      },
      {
        'service_id': 15,
        'service_name': 'Hospitality Fast Grow ',
        'service_name_str': 'HospitalityFastGrow_str',
        'service_desc': 'HospitalityFastGrow',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/PosSystem/TAPTOUCH LOGO.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/PosSystem/TAPTOUCH LOGO.png\']',
        'service_price': 5900,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 3,
          'service_id': 15
        },
        'service_model': []
      }
    ]
  },
  {
    'service_package_id': 4,
    'service_package_name': 'Hospitality Advance',
    'service_package_desc': '服务业高级方案',
    'service_package_image': [
      'https://api.miepay.xyz/storage/shop/progress/service/servicePackage/Hospitality.jpg'
    ],
    'service_package_price': 31505,
    'created_at': null,
    'updated_at': null,
    'deleted_at': null,
    'is_choose': false,
    'service': [
      {
        'service_id': 18,
        'service_name': 'Mie Wireless internet 20/5 Unlimited',
        'service_name_str': 'MieWirelessinternet205Unlimited_str',
        'service_desc': 'MieWirelessinternet205Unlimited',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/InternetService/wareless nation/wn-miepay.jpg'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/InternetService/wareless nation/wn-miepay.jpg\']',
        'service_price': 12900,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 4,
          'service_id': 18
        },
        'service_model': []
      },
      {
        'service_id': 19,
        'service_name': 'SUNMI T2s Dual Touch',
        'service_name_str': 'SUNMIT2sDualTouch_str',
        'service_desc': `SUNMIT2sDualTouch`,
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/PosHardware/sunmi/T2/T2双大屏_左侧面.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/PosHardware/sunmi/T2/T2双大屏_左侧面.png\']',
        'service_price': 10500,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 4,
          'service_id': 19
        },
        'service_model': []
      },
      {
        'service_id': 8,
        'service_name': 'Taptouch  C3540',
        'service_name_str': 'TaptouchC3540_str',
        'service_desc': 'TaptouchC3540',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch  C3540/C3540-open-Logo.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch  C3540/C3540-open-Logo.png\']',
        'service_price': 590,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 4,
          'service_id': 8
        },
        'service_model': []
      },
      {
        'service_id': 7,
        'service_name': 'Smart Box',
        'service_name_str': 'SmartBox_str',
        'service_desc': 'SmartBox',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/1.jpg',
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/2.jpg',
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/3.jpg'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/1.jpeg\',\'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/2.jpeg\',\'https://api.miepay.xyz/storage/shop/progress/service/consumables/Smart Box/3.jpeg\']',
        'service_price': 625,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 4,
          'service_id': 7
        },
        'service_model': []
      },
      {
        'service_id': 15,
        'service_name': 'Hospitality Fast Grow ',
        'service_name_str': 'HospitalityFastGrow_str',
        'service_desc': 'HospitalityFastGrow',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/PosSystem/TAPTOUCH LOGO.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/PosSystem/TAPTOUCH LOGO.png\']',
        'service_price': 5900,
        'service_is_offline_pay': 0,
        'service_is_show': 0,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 4,
          'service_id': 15
        },
        'service_model': []
      },
      {
        'service_id': 10,
        'service_name': 'Taptouch S300H',
        'service_name_str': 'TaptouchS300H_str',
        'service_desc': 'TaptouchS300H',
        'service_image': [
          'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch S300H/开盖.png'
        ],
        'service_type': 'CONSUMABLES',
        'service_icon': '[\'https://api.miepay.xyz/storage/shop/progress/service/consumables/taptouch S300H/开盖.png\']',
        'service_price': 990,
        'service_is_offline_pay': 0,
        'service_is_show': 1,
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
        'pivot': {
          'service_package_id': 4,
          'service_id': 10
        },
        'service_model': []
      }
    ]
  }
]
export { step3data1 }
